<template>
    <div class="popup modal fade">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="list-content">
                <ul>
                  <li v-for="(item,index) in users" :key="index">
                    <span class="job"><b>{{ item.job }}</b></span>
                    <span class="name">{{ item.name }}</span>
                  </li>
                </ul>
              </div>
            <div>
              <div class="popup-btn">
                <a  @click="closePopup"><b>返回</b></a>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
  export default {
    props:{
      users:{
        type:Array,
        required:true
      }
    },
    data(){
      return{

      }
    },
    mounted() {
      console.log("user",this.users)
    },
    methods: {
      closePopup(e){
        e.stopPropagation();
        this.$emit("closeChanged",false);
      }
    },
  }
</script>
<style scoped lang="scss">
  .list-content{
    background: #fff;
    max-height: 613px;
    max-width: 587px;
    border: 7px solid rgba(151,151,151,0.05);
    border-radius: 30px;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
    ul{
      padding: 0;
      margin: 0;
      list-style: none;
    }
    li{
      min-height: 60px;
      &:nth-child(even){
        background: rgb(251, 251, 251);
      }
      span{
        display: inline-block;
        font-size: 18px;
        letter-spacing: 0.9px;
        line-height: 30px;
        vertical-align: middle;
        padding: 15px 30px 15px 45px;
      }
      .job{
        width: 30%;
        color: #2A1C15;
        font-weight: 500;
        border-right: solid 1px #f5f4f4;
      }
      .name{
        width: calc(70% - 5px);
        color: #261A16;
        text-align: justify;
      }
    }
  }
  .popup{
    width: 110%;
    height: 100%;
    display:block;
    background: rgba(0,0,0,0.7);
    .modal-content{
      background: none;
      border: 0;
      position: absolute;
    }
    .popup-btn{
      height: 60px;
      line-height: 60px;
      width: 250px;
      border-radius: 35px;
      background-color: #F5AC2D;
      margin: auto;
      margin-top:52px;
      cursor: pointer;
      a{
        width: 100%;
        display: inline-block;
        color: #262D35;
        font-size: 20px;
        font-weight: 500;
        text-align: center;
      }
    }
  }
  @media (max-width:1080px){
    .popup{
      padding: 30px 20px;
      width: 100%;
      background: rgba(255,255,255,0.9);
      .modal-content{
        top: 50%;
        margin-top: -229px;
        img{
          width: 100%;
          height: 100%;

        }
      }
    }
    .list-content{
      height: 434px;
      overflow: auto;
      li{
        min-height: 44px;
        span{
          padding: 10px 10px;
          font-size: 14px;
          line-height: 24px;
        }
      }
    }
  }
  @media (min-width: 576px){
    .modal-dialog {
      max-width: 590px;
      margin: 1.75rem auto;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/default/Popup.vue